var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 98,
    viewBox: "0 0 83 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#98daf0;}.b{fill:none;stroke:#1c2253;stroke-miterlimit:10;stroke-width:4px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1084.75 -1692)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 41.5,
    cy: 41.5,
    r: 41.5,
    transform: "translate(1084.75 1692)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 19.024,
    cy: 18.55,
    rx: 19.024,
    ry: 18.55,
    transform: "translate(1107.441 1706.857)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-117.667,779s17.143,3.429,17.143,38.857c-8.571,8.571-21.714,11.429-29.714,11.429h-5.714c-8,0-21.143-2.857-29.714-11.429,0-35.429,17.143-38.857,17.143-38.857",
    transform: "translate(1259.559 958.714)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamIcon);
export default __webpack_public_path__ + "static/media/team-icon.eae67db4435c50f53181b9bec9cf185f.svg";
export { ForwardRef as ReactComponent };